<template>
  <div class="tr-test game-tr-test-multi">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="overflow-element"
      :class="[{ 'overflow-with-image': objectImageExist(imageData) }]"
      :style="getStyle(imageData)"
    >
      <div
        class="element-container"
        :class="[
          { 'question-container-image': isImageInQuestion(element) },
          { 'element-container-vertical': element.vertical },
          { block: inputStatus(elementIndex) === 'correct' },
        ]"
        :style="'height:' + manualElementHeight + 'px;'"
        v-for="(element, elementIndex) in questionsList"
        :key="'element_' + elementIndex"
        :id="'element_' + elementIndex"
      >
        <div class="question-container inner-element-container" v-if="isQuestion(element.question)">
          <div class="question-text" v-html="element.question"></div>
        </div>
        <div
          class="answer-container inner-element-container"
          :class="[{ 'no-questoin-class': !isQuestion(element.question) }]"
        >
          <div
            class="answer-item"
            @click="resetCheckStatus"
            v-for="(answer, answerIndex) in element.answers"
            :key="answerIndex"
          >
            <div class="">
              <label class="label-container">
                <div class="text-container" v-if="isText(answer)" v-html="answer.text"></div>
                <div class="image-container" :style="'background-image: url(' + getImage(answer) + ');'" v-else></div>
                <input
                  type="radio"
                  :name="'element_' + elementIndex"
                  :value="answer.value"
                  v-model="selected['element_' + elementIndex]"
                />
                <span
                  class="checkmark"
                  :class="[
                    { correct: inputStatus(elementIndex) === 'correct' },
                    { incorrect: inputStatus(elementIndex) === 'incorrect' },
                  ]"
                ></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'tr-test-multi-v2',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      baseQuestionsList: _.cloneDeep(this.startGameConfig.items),
      manualElementHeight: this.startGameConfig.questionElementHeight,
      questonShuffle: this.startGameConfig.shuffle,
      imageData: {},
      selected: {},
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.questionsList = this.processQuestionsList();
      _.each(_.cloneDeep(this.questionsList), (question, questionIndex) => {
        this.selected = Object.assign({}, this.selected, {
          ['element_' + questionIndex]: '',
        });
        _.each(question.answers, (answer, answerIndex) => {
          this.questionsList[questionIndex].answers[answerIndex] = Object.assign(
            {},
            this.questionsList[questionIndex].answers[answerIndex],
            {
              value: this.questionsList[questionIndex].answers[answerIndex].correct
                ? 'CORRECT'
                : 'question' + questionIndex + 'answer' + answerIndex,
              checked: false,
            }
          );
        });
      });
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(this.getCustomStyle(imageData), {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStyle(item) {
      let height;
      /** @type {Number} margin-bottom:10px; in main-image-container */
      let imageMarginBottom = 10;
      if (item.height) {
        /** 795 is height available scen */
        height = 795 - item.height - imageMarginBottom;
        if (!_.isNumber(height) || height < 0) {
          height = undefined;
        }
      }
      return _.merge({ height: [height, 'px'].join('') }, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] === 'CORRECT') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    isText(obj) {
      return _.has(obj, 'text');
    },
    isQuestion(obj) {
      return !_.isEmpty(obj);
    },
    isImageInQuestion(obj) {
      return _.some(obj.answers, 'imagePath');
    },
    selectRadioButto(qIndex, aIndex) {
      let element = this.$refs['question' + qIndex + 'answer' + aIndex];
      this.selected['element_' + qIndex + '_' + aIndex] = element[0].value;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      // this.gameCheckSwitch = false;
      _.each(this.selected, (item, key, collection) => {
        collection[key] = '';
        document.querySelector(['#', key].join('')) &&
          document.querySelector(['#', key].join('')).classList.remove('block');
      });
      this.init();
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value === 'CORRECT') {
            temVal = result && true;
          } else {
            temVal = false;
            // this.selected[ key ] = "";
            // setTimeout( () => {
            //   this.selected[ key ] = "";
            // }, 2000 );
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
    processQuestionsList() {
      let newQuestionList = [];
      let selectedItem;
      if (this.startGameConfig.pick && this.startGameConfig.items) {
        selectedItem = _.sample(_.cloneDeep(this.startGameConfig.items));
      } else {
        selectedItem = this.startGameConfig;
      }
      // let selectedItem = _.sample( _.cloneDeep(this.startGameConfig.items) );
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = _.cloneDeep(this.startGameConfig.mainImage);
      }
      if (selectedItem.pick) {
        selectedItem.questionsList = _.sampleSize(_.cloneDeep(selectedItem.questionsList), selectedItem.pick);
      }
      _.each(_.cloneDeep(selectedItem.questionsList), (item, index) => {
        if (item.items && item.pick) {
          item = _.sampleSize(_.cloneDeep(item.items), item.pick)[0];
        }
        let question = item.question;
        let answers = item.answers;
        let vertical = item.vertical;
        if (item.pick) {
          // this.questionsList[index].answers = _.sampleSize(item.answers,item.pick);
          answers = _.sampleSize(_.cloneDeep(item.answers), item.pick);
        }
        if (item.shuffle) {
          answers = _.shuffle(item.answers);
        }
        newQuestionList.push({ question, answers, vertical });
      });
      this.questionsList = this.questonShuffle ? _.shuffle(newQuestionList) : newQuestionList;
      return this.questionsList;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
// @import '~@/assets/sass/testBase';
// @import '~@/assets/sass/testMulti';
$elementWidth: 1853px;
$elementHeight: 153px;
.label-container {
  @media (min-width: 1200px) {
    max-width: 97%;
    width: 1780px;
  }
}
.game-tr-test-multi {
  position: relative;
  top: 160px;
  left: 11px;
  display: block;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  // height: 865px;
  height: 795px;
  width: 1906px;
  // padding: 160px 56px 127px 11px;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  // overflow-y: scroll;
  font-size: 28px;
  // height: 100%;
  .block {
    pointer-events: none;
  }
  // .overflow-with-image {
  //     height: 35% !important;
  // }
  .overflow-element {
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
    .element-container {
      position: relative;
      display: block;
      width: $elementWidth;
      height: $elementHeight;
      border-radius: 20px;
      border: 3px solid $backgroundControlPanelColor;
      margin-bottom: 20px;
      .inner-element-container {
        display: block;
        // position: absolute;
        width: 100%;
        height: 30%;
      }
      .question-container {
        height: 40%;
        // background-color: rgba(227, 230, 123, 0.29);
        .question-text {
          line-height: 28px;
          text-align: left;
          padding-top: 28px;
          padding-left: 35px;
          padding-right: 35px;
        }
      }
      .answer-container {
        height: 60%;
        // background-color: rgba(6, 45, 172, 0.36);
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        .answer-item {
          display: flex;
          min-width: 22%;
          justify-content: flex-start;
          align-items: center;
          height: 49px;

          /* The label-container */
          .label-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            height: 49px;
            padding-left: 70px;
            margin-bottom: 12px;
            cursor: pointer;
            // font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            .text-container {
              text-align: left;
            }
            .image-container {
              // width: 250px;
              // height: 250px;
              width: 200px;
              height: 180px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
            }
          }

          /* Hide the browser's default radio button */
          .label-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          /* Create a custom radio button */
          .checkmark {
            position: absolute;
            top: 0;
            left: 8px;
            height: 49px;
            width: 49px;
            background-image: url('~@/assets/icons/both/game/testIcons/default.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            border-radius: 50%;
          }

          /* On mouse-over, add a grey background color */
          // .label-container:hover input ~ .checkmark {
          //     // background-color: #ccc;
          //     background-image: url("~@/assets/icons/both/game/testIcons/set.png");
          // }

          /* When the radio button is checked, add a blue background */
          .label-container input:checked ~ .checkmark {
            background-image: url('~@/assets/icons/both/game/testIcons/set.png');
          }
          // correct style
          .label-container input:checked ~ .checkmark.correct {
            background-image: url('~@/assets/icons/both/game/testIcons/correct.png');
          }
          // incorrect style
          .label-container input:checked ~ .checkmark.incorrect {
            background-image: url('~@/assets/icons/both/game/testIcons/incorrect.png');
          }

          /* Create the indicator (the dot/circle - hidden when not checked) */
          .checkmark:after {
            content: '';
            position: absolute;
            display: none;
          }

          /* Show the indicator (dot/circle) when checked */
          .label-container input:checked ~ .checkmark:after {
            display: block;
          }

          /* Style the indicator (dot/circle) */
          .label-container .checkmark:after {
            // top: 9px;
            // left: 9px;
            // width: 8px;
            // height: 8px;
            // border-radius: 50%;
            // background: white;
            visibility: hidden;
          }
        }
      }
      .no-questoin-class {
        height: 100%;
      }
    }
    .element-container-vertical {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .answer-container {
        height: 100%;
        padding-left: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
      }
    }
    .question-container-image {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
    }
  }
  .main-image-container {
    position: relative;
    display: block;
    width: $elementWidth;
    height: $elementHeight;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
